(() => {
  const key = 'ironstep-vat-price-view';
  let mode = 'without';
  try { if (localStorage.getItem(key) === 'with') mode = 'with'; } catch {}
  const listeners = new Set();
  const update = (next) => {
    mode = next === 'with' ? 'with' : 'without';
    document.documentElement.dataset.ironstepVatView = mode;
    for (const listener of listeners) listener();
  };
  class VatAmount extends HTMLElement {
    static observedAttributes = ['data-without', 'data-with'];
    attributeChangedCallback() { this.refresh(); }
    refresh = () => {
      const value = this.dataset[mode];
      if (value !== undefined && this.textContent !== value) this.textContent = value;
    };
    observer = new MutationObserver(() => this.refresh());
    connectedCallback() {
      listeners.add(this.refresh);
      this.observer.observe(this, { childList: true, characterData: true, subtree: true });
      this.refresh();
    }
    disconnectedCallback() { listeners.delete(this.refresh); this.observer.disconnect(); }
  }
  class VatLabel extends VatAmount {}
  class VatToggle extends HTMLElement {
    observer = new MutationObserver(() => this.refresh());
    refresh = () => {
      const input = this.querySelector('input');
      if (input) input.checked = mode === 'with';
      this.dataset.mode = mode;
      this.hidden = false;
    };
    change = () => {
      update(this.querySelector('input').checked ? 'with' : 'without');
      try { localStorage.setItem(key, mode); } catch {}
    };
    connectedCallback() {
      listeners.add(this.refresh);
      this.addEventListener('change', this.change);
      this.observer.observe(this, { attributes: true, attributeFilter: ['hidden'], childList: true, subtree: true });
      this.refresh();
      this.hidden = false;
    }
    disconnectedCallback() {
      listeners.delete(this.refresh);
      this.removeEventListener('change', this.change);
      this.observer.disconnect();
    }
  }
  if (!customElements.get('ironstep-vat-amount')) customElements.define('ironstep-vat-amount', VatAmount);
  if (!customElements.get('ironstep-vat-label')) customElements.define('ironstep-vat-label', VatLabel);
  if (!customElements.get('ironstep-vat-toggle')) customElements.define('ironstep-vat-toggle', VatToggle);
  window.addEventListener('storage', (event) => { if (event.key === key) update(event.newValue); });
  update(mode);
})();
